import { compose } from 'recompose';
import { connect } from 'react-redux';

import { getSymbolForCurrency } from '../money';
import { getCurrency } from '../../auth/selectors';

export default compose(
  connect((state, props) => {
    const currency = props.currency || getCurrency(state);
    return {
      currency,
      currencySymbol: getSymbolForCurrency(currency),
    };
  }),
);
